import React from 'react';
import myzithraCheese from '../../../../src/assets/images/myzithra.jpg'; // Adjust the path to your image file
import './Myzithra.styled.css';

const MyzithraSection = () => {
    return (
        <section className="flex flex-col items-center md:flex-row w-full myzithra-section py-5">
            <div className="w-full md:w-3/5 flex flex-col items-center justify-center mt-4 px-6 md:px-12 md:p-0">
                <div className="w-full rounded-lg text-center myzithra-info px-6 md:px-12">
                    <h1 className="text-2xl md:text-5xl font-bold text-gray-900 text-[#DC143C]">Dry Mizithra <br/>A Greek Classic</h1>
                    <p className="mt-6 text-m md:text-xl text-gray-700 flex items-center">
                    Dry mizithra is a hard, aged cheese made primarily from sheep's or goat's milk whey, sometimes enriched with a bit of whole milk to enhance its texture. With origins in Crete, mizithra is one of Greece’s oldest and most cherished cheeses.
                    </p>
                    <p className="text-m md:text-xl text-gray-700 flex items-center">
                    The dry variety of mizithra is aged to develop a firm, crumbly texture and a sharp, salty flavor. Prized for its nutty taste and granular consistency, similar to Italian pecorino or Parmesan, it is perfect for grating over pasta dishes, vegetables, and salads, adding a bold and savory touch to Greek cuisine.</p>
                </div>
            </div>
            <div className="h-full w-full flex justify-center items-center ml-0 md:mr-8 mb-4 md:mb-0 md:w-2/5 py-4">
                <img src={myzithraCheese} alt="Myzithra Cheese" className="myzithra-section-img object-cover h-full w-full rounded" />
            </div>

        </section>
    );
};

export default MyzithraSection;
